(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["echta-material-identity"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('echta-material-identity')) {
    customElements.define('echta-material-identity', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.dialog = this.querySelector('dialog');
        this.trigger = this.querySelector('.echta-mi__trigger');
        this.trigger.addEventListener('click', () => {
          this.previousOverflow = document.documentElement.style.overflow;
          this.dialog.showModal();
          document.documentElement.style.overflow = 'hidden';
        });
        this.querySelector('.echta-mi__close').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('click', event => {
          const bounds = this.dialog.getBoundingClientRect();
          if (event.target === this.dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => {
          document.documentElement.style.overflow = this.previousOverflow || '';
          this.trigger.focus({preventScroll:true});
        });
      }
      disconnectedCallback() {
        if (this.dialog && this.dialog.open) {
          this.dialog.close();
          document.documentElement.style.overflow = this.previousOverflow || '';
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
